// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=Translation|schemaHash=ce800c234fefe07a316fe46b110d6b5f11f8d8c6

import { setDefinedValue } from '@myre/common-primitives';

export function parseTranslationFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'current', _data.current);
  setDefinedValue(result, 'de', _data.de);
  setDefinedValue(result, 'en', _data.en);
  setDefinedValue(result, 'fr', _data.fr);
  setDefinedValue(result, 'es', _data.es);

  return result;
}

export function parseTranslationToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'current', _data.current);
  setDefinedValue(result, 'de', _data.de);
  setDefinedValue(result, 'en', _data.en);
  setDefinedValue(result, 'fr', _data.fr);
  setDefinedValue(result, 'es', _data.es);

  return result;
}
